import { render, staticRenderFns } from "./AdminCategoryList.vue?vue&type=template&id=e506dda2&scoped=true&"
import script from "./AdminCategoryList.vue?vue&type=script&lang=js&"
export * from "./AdminCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategoryList.vue?vue&type=style&index=0&id=e506dda2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e506dda2",
  null
  
)

export default component.exports